import React from 'react';
import {connect} from 'react-redux';
import { Field, formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import {Button, Card, CardBody, Col, FormGroup} from 'reactstrap';
import ReduxFormInput from "@Utils/ReduxFormInput";
import validate, {ArsenalArmyCreateParams} from "./validate";
import {AppState} from "@Redux/store";
import {Dispatch} from "@Redux/type";
import {container} from "@Container";
import {ArmyCategoriesAction} from "@Redux/actions";
import {TYPES} from "@Types";
import ReduxFormSelect from "@Utils/ReduxFormSelect";
import {ArmyCategoriesPresenter} from "@Selectors/arsenal/new/ArmyCategoriesPresenter";
import { GameView } from '@Selectors/builder/myArmyList/common/ArmyListView';
import { VersionGame } from '@Models';
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';

interface Props {
  cancel: () => void,
  onSubmit: (values: ArsenalArmyCreateParams) => void,
  canSubmit: boolean,
}

const Form: React.FC<FormProps & InjectedFormProps<ArsenalArmyCreateParams, FormProps>> = ({
                                                                                             games,
                                                                                     armies,
                                                                                     fetchArmyCategories,
                                                                                     cancel,
                                                                                     handleSubmit,
                                                                                     canSubmit
                                                                                   }) => {
  React.useEffect(() => {
    fetchArmyCategories();
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      <Col sm="12">
        <Card className="card-border">
          <CardBody>
            <h2 className="text-center"><FormattedMessage {...defaultMessages.arsenalArmyNewTitle} /></h2>

            <FormGroup row={true}>
              <Col xs="12" md={6} lg="4">
                <Field
                  name="game"
                  type="text"
                  datas={games}
                  component={ReduxFormSelect}
                  label={defaultMessages.arsenalArmyFormGameTitle}
                  placeHolder={defaultMessages.arsenalArmyFormGamePlaceholder}
                />
              </Col>
              <Col xs="12" md={6} lg="4">
                <Field
                  name="armyCategoryId"
                  type="text"
                  datas={armies}
                  component={ReduxFormSelect}
                  label={defaultMessages.arsenalArmyFormArmyTitle}
                  placeHolder={defaultMessages.arsenalArmyFormArmyPlaceholder}
                />
              </Col>
              <Col xs="12" md={12} lg="4">
                <Field
                  name="name"
                  type="text"
                  component={ReduxFormInput}
                  label={defaultMessages.arsenalArmyFormNameTitle}
                  placeHolder={defaultMessages.arsenalArmyFormNamePlaceholder}
                />
              </Col>
            </FormGroup>
          </CardBody>
          <div className="mb-2 text-center">
            <Button disabled={!canSubmit} onClick={() => cancel()} color="age"
                    type="button"><FormattedMessage {...defaultMessages.formCancel} /></Button>
            <Button disabled={!canSubmit} color="age" type="submit"><FormattedMessage {...defaultMessages.formCreate} /></Button>
          </div>
        </Card>
      </Col>
    </form>
  );
}

const NewArsenalArmyForm = reduxForm<ArsenalArmyCreateParams, FormProps>({
  form: 'new_arsenal_army',
  validate,
})(Form);

// Decorate with connect to read form values
// @ts-ignore
const selector = formValueSelector('new_arsenal_army') // <-- same as form name

const mapStateToProps = (state: AppState, props: Props) => {
  return {
    games: new Array<GameView>(
      { id: VersionGame.NinthAge, name: 'Ninth Age' } satisfies GameView as GameView,
      { id: VersionGame.WarhammerBattle, name: 'Warhammer Battle' } satisfies GameView as GameView,
      { id: VersionGame.EssenceOfWar, name: 'Essence of War' } satisfies GameView as GameView,
      { id: VersionGame.TheOldWorld, name: 'The Old World' } satisfies GameView as GameView,
    ),
    armies: ArmyCategoriesPresenter(state),
    onSubmit: props.onSubmit,
    initialValues: {
      game: VersionGame.NinthAge,
    },
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  const armiesAction = container.get<ArmyCategoriesAction>(TYPES.Actions.ArmyCategoriesAction)

  return {
    fetchArmyCategories: () => dispatch(armiesAction.fetchData()),
  };
};

type FormProps = Props &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>

export default connect(mapStateToProps, mapDispatchToProps)(NewArsenalArmyForm);
